import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Form, Grid, Header, Image, Input, Message, Segment } from 'semantic-ui-react';
import { showLoading, hideLoading, loginStaff, logoutStaff } from '../actions';
import logo from '../assets/img/logo.png';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            errorMsg: '',
            errorOpen: false
        }

        this.handleLogin = this.handleLogin.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCloseError = this.handleCloseError.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user && nextProps.user.state === 'INACTIVE') {
            this.setState({
                errorMsg: 'Account is inactive. Please contact admin for assistance!',
                errorOpen: true
            });
        }
    }

    handleLogin(e) {
        e.preventDefault();
        this.props.showLoading('Logging in . . . ');
        // TODO: perform form validation
        this.props.firebaseApp.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
            .then((userCredentials) => {
                console.log(userCredentials.user);
                if (userCredentials.user) {
                    this.props.loginStaff(userCredentials.user);
                } else {
                    console.log('User has logged out!');
                    this.props.logoutStaff();
                }
                // this.props.hideLoading();
            })
            .catch((err) => {
                console.log(err);
                this.setState({ errorMsg: err.message, errorOpen: true });
                this.props.hideLoading();
            });
    }

    handleResetPassword(e) {
        e.preventDefault();
        this.props.history.push('/reset_password');
    }

    handleInputChange(e) {
        this.setState({ [e.target.id]: e.target.value });
    }

    handleCloseError(e) {
        this.setState({ errorMsg: '', errorOpen: false });
    }

    render() {
        const { email, password, errorMsg, errorOpen } = this.state;

        return (
            <div className='login-form'>
                {/*
                Heads up! The styles below are necessary for the correct render of this example.
                You can do same with CSS, the main idea is that all the elements up to the `Grid`
                below must have a height of 100%.
                */}
                <style>{`
                body > div,
                body > div > div,
                body > div > div > div.login-form {
                    height: 100%;
                }
                `}</style>
                <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Image src={logo} verticalAlign='middle' size='medium' />
                        <Header as='h2' color='black' textAlign='center'>
                            Dashboard
                        </Header>
                        <Form size='large' onSubmit={this.handleLogin}>
                            <Segment stacked>
                                <Form.Input fluid icon='user' iconPosition='left' placeholder='E-mail address' id='email' value={email} onChange={this.handleInputChange} autoFocus='true' />
                                <Form.Input
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    placeholder='Password'
                                    type='password'
                                    id='password'
                                    value={password}
                                    onChange={this.handleInputChange}
                                />

                                <Button color='blue' fluid size='large' type='submit'>
                                    Login
                                </Button>
                            </Segment>
                        </Form>
                        <Message hidden={errorOpen}>
                            <Message.Header>Forgot password?</Message.Header>
                            Click on <a href='#' onClick={this.handleResetPassword.bind(this)}>Reset Password</a>
                        </Message>
                        <Message negative hidden={!errorOpen} onDismiss={this.handleCloseError}>
                            <Message.Header>Login failed</Message.Header>
                            <p>{errorMsg}</p>
                        </Message>
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = ({ auth }) => {
    return { firebaseApp: auth.firebaseApp, user: auth.user };
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showLoading: showLoading,
        hideLoading: hideLoading,
        loginStaff: loginStaff,
        logoutStaff: logoutStaff
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Login);
